//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from '../Components/Component';
import {isNullOrUndefined} from '../Utils';

//endregion

/** */
type Props = {
    title: string;
    message?: string;
    children: JSX.Element | JSX.Element[] | string;
}

/** */
class MTemplateOne extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <div className="flex flex-column justify-content-center align-items-center" style={{'minHeight': '100vh'}}>
                <div className="flex flex-row align-items-center mb-2">
                    <div className="flex flex-column mr-3">
                        <img src="/logo48.png" alt="logo"/>
                    </div>
                    <div className="flex flex-column text-5xl weight-semibold">
                        {this.props.title}
                    </div>
                </div>
                {
                    !isNullOrUndefined(this.props.message) &&
                    <div className="flex flex-row text-xl text-center mb-3">
                        {this.props.message}
                    </div>
                }
                <div className="flex flex-row">
                    {this.props.children}
                </div>
            </div>
        );

    }

}

export default MTemplateOne;
